<template>
  <div @click="autoClear" class="alert" v-if="error || notification">
    <p class="error" v-if="error">{{error}}</p>
    <p class="notification" v-if="notification">{{notification}}</p>
  </div>
</template>

<script>
import messages from "@/utils/messages";


export default {
  methods:{
    autoClear(){
      this.$store.commit('setError', null)
      this.$store.commit('setNotification', null)
    }
  },
  computed:{
    error(){
      return messages[this.$store.getters.getError]
    },
    notification(){
      return messages[this.$store.getters.getNotification]
    }
  }
}
</script>

<style lang="scss">
.alert{
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  top: 25px;
  left: 0;
  right: 0;
  z-index: 10000;
  .error{
    color: #fff;
    background: tomato;
    padding: 25px;
    margin-bottom: 20px;
    border-radius: 0px 20px 0px 20px;
  }
  .notification{
    color: #fff;
    background: #31d766;
    padding: 25px;
    border-radius: 0px 20px 0px 20px;

  }
}
</style>